module.exports = __webpack_public_path__ + "static/img/pad6.afcfcb4d.png";